import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import RootContext from '../../context';
import { PATH_ROOT, PATH_INTRO } from '../../paths';
// import head from '../../../assets/head.svg';
// import { CentralContainer, CentralText } from '../Loading/styles';

export const Waiting = () => {
  const { videoParams } = useContext(RootContext);
  if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  return (
    <>
    </>
  );
};
/*
      <CentralContainer>
        <img src={head}/>
        <CentralText>
          Processing active liveness
          <br/>
          It can take some time
          <br/>
          Do not close the browser
        </CentralText>
      </CentralContainer>

 */
